const personalInformation = [
	{
		//个人信息
		path: '/personal',
		name: 'personal',
		component: resolve => require(['@/views/personal/v2/index'], resolve),
		meta: {
			isHide: true,
			isPermission: true
		}
	},
	{
		//绑定
		path: '/bindinGoogle',
		name: 'bindinGoogle',
		component: resolve =>
			require([
				'@/views/personal/v2/system-security/bingGoogle/index'
			], resolve),
		meta: {
			isHide: true
		}
	},
	{
		//解绑
		path: '/unBindGoogle',
		name: 'unBindGoogle',
		component: resolve =>
			require([
				'@/views/personal/v2/system-security/unBindGoogle/index'
			], resolve),
		meta: {
			isHide: true
		}
	},
	{
		path: '/modify-login-pwd',
		name: 'modifyLoginPwd',
		component: resolve =>
			require([
				'@/views/personal/v2/system-security/changeLoginPassword/index'
			], resolve),
		meta: {
			isHide: true
		}
	},
	{
		path: '/modify-email',
		name: 'modifyEmail',
		component: resolve =>
			require([
				'@/views/personal/v2/system-security/changeEmail/index'
			], resolve),
		meta: {
			isHide: true
		}
	},
	{
		path: '/modify-mobile',
		name: 'modifyMobile',
		component: resolve =>
			require([
				'@/views/personal/v2/system-security/changeMobile/index'
			], resolve),
		meta: {
			isHide: true
		}
	},
	{
		path: '/setfundPassword',
		name: 'setfundPassword',
		component: resolve =>
			require([
				'@/views/personal/v2/system-security/setfundPassword/index'
			], resolve),
		meta: {
			isHide: true
		}
	},
	{
		path: '/fish-code',
		name: 'fishCode',
		component: resolve =>
			require(['@/views/personal/v2/system-security/fish-code.vue'], resolve),
		meta: {
			isHide: true
		}
	},
	{
		path: '/kyc',
		name: 'kyc',
		component: resolve =>
			require(['@/views/personal/v2/mobile/kyc/index.vue'], resolve),
		meta: {
			isHide: true
		}
	},
	{
		path: '/securitysetting',
		name: 'securitysetting',
		component: resolve =>
			require([
				'@/views/personal/v2/mobile/securitysetting/index.vue'
			], resolve),
		meta: {
			isHide: true
		}
	},
	{
		path: '/Accountability',
		name: 'Accountability',
		component: resolve =>
			require(['@/views/personal/v2/mobile/Accountability/index.vue'], resolve),
		meta: {
			isHide: true
		}
	}
]

export default personalInformation
